import { Component, signal } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Alert, AlertsService, I18NService, UserService } from '@socrates/socrates-shared';

@Component({
	selector: 'password-reset',
	templateUrl: './passwordReset.component.html',
	standalone: false,
})
export class PasswordResetComponent {
	private _resetForm: FormGroup;
	private _submitted = false;
	private _canceling = false;
	readonly submitting = signal(false);
	private readonly _placeholders: any;

	constructor(
		private alertsService: AlertsService,
		private userService: UserService,
		private router: Router,
		private formBuilder: FormBuilder
	) {
		this._resetForm = this.formBuilder.group({
			email: ['', [Validators.required, Validators.email]]
		});

		this._placeholders = {
			username: I18NService.getMessage('login.passwordReset.placeholders.emailPrompt')
		};
		this.alertsService.clearAlerts();
	}

	async onSubmit(): Promise<void> {
		if (!this._canceling) {
			if (this._resetForm.valid) {
				this.submitting.set(true);
				const email: string = this.resetForm.controls['email'].value as string;
				try {
					await this.userService.resetPassword(email);
					this.submitting.set(false);
					this.router.navigate(['/passwordConfirm'], { queryParams: { username: email } });
				} catch (error: any) {
					this.submitting.set(false);
					this.alertsService.addAlert(new Alert({
						message: I18NService.getMessage('dashboard.password.errorMsgs.noReset'),
						alertType: 'error',
						namespace: 'pwdr'
					}));
				}
			} else {
				this._submitted = true;
			}
		}
	}

	onCancel(): void {
		this._canceling = true;
		this.router.navigate(['/login']);
	}

	getMessage(key: string): string {
		return I18NService.getMessage(key);
	}

	get formControls() { return this._resetForm.controls; }
	get resetForm(): FormGroup { return this._resetForm; }
	get submitted(): boolean { return this._submitted; }
	get placeholders(): any { return this._placeholders; }
}
